import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';
import { PayoutStatus } from './enums/PayoutStatus';

export class PayoutTransactionsPaginated {
  @Type(() => PayoutTransactionItem)
  items: PayoutTransactionItem[];

  @Expose({ name: 'next_page_url' })
  nextPageUrl?: string;

  constructor(items: PayoutTransactionItem[], nextPageUrl?: string) {
    this.items = items;
    this.nextPageUrl = nextPageUrl;
  }

  get cursor(): string | null {
    return this.nextPageUrl == null
      ? null
      : new URL(this.nextPageUrl).searchParams.get('cursor');
  }

  static fromJson(json: Record<string, any>): PayoutTransactionsPaginated {
    return plainToInstance(PayoutTransactionsPaginated, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class PayoutTransactionItem {
  id: number;

  @Expose({ name: 'status_id' })
  status: PayoutStatus;

  total: string;

  fee: string;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  dateCreated: Date;

  constructor(
    id: number,
    status: PayoutStatus,
    total: string,
    fee: string,
    dateCreated: Date
  ) {
    this.id = id;
    this.status = status;
    this.total = total;
    this.fee = fee;
    this.dateCreated = dateCreated;
  }

  static fromJson(json: Record<string, any>): PayoutTransactionItem {
    return plainToInstance(PayoutTransactionItem, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
